/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { ValidationPolicy, ValidationTypeEnum } from "@common/model/validationPolicy";
export enum PolicyTypeEnum {
    PASSWORD_POLICY = 1,
    VAULT_KEY_POLICY = 2,
    RESET_PASSWORD_POLICY = 4,
    RESET_VAULT_KEY_POLICY = 8
}

export interface IValidationService {
    setAndProcessPolicy(policyType: PolicyTypeEnum, policies: Array<ValidationPolicy>): void;
    get(policyType: PolicyTypeEnum): Array<ValidationPolicy>;
    getHtmlTooltip(policyType: PolicyTypeEnum): string;
    getPwdErrMessage(policyType: PolicyTypeEnum): string;
    isValidValue(policyType: PolicyTypeEnum, value: string): boolean;
    getExipryDays(policyType: PolicyTypeEnum): string;
}

export class ValidationService implements IValidationService {
    validationPolicies: any = {};

    static $inject = [];
    constructor() { }

    get(policyType: PolicyTypeEnum) {
        return this.validationPolicies[policyType];
    }

    setAndProcessPolicy(policyType: PolicyTypeEnum, policies: Array<ValidationPolicy>) {
        this.validationPolicies[policyType] = {
            policyType: policyType,
            policies: policies,
            htmlToolTip: "",
            validationString: "",
            errorMessage: ""
        };
        var config = this.getConfigForPolicy(policyType);
        this.validationPolicies[policyType].htmlToolTip = config.tooltip;
        this.validationPolicies[policyType].validationString = config.validationString;
        this.validationPolicies[policyType].errorMessage = config.errorMessage;
    }

    getConfigForPolicy(policyType: PolicyTypeEnum) {
        var rtnToolTip = "";
        var policies = this.validationPolicies[policyType].policies;
        if (Array.isArray(policies)) {
            var vTypes = ValidationTypeEnum;
            var tipData = [];
            var validations = [];
            //var errMsgs = [];
            var minLenPolicy, maxLenPolicy;
            var s, prefix;
            policies.forEach(policy => {
                s = (typeof policy.value == "number" && policy.value > 1 ? "s" : "");
                switch (policy.validationType) {
                    case vTypes.MIN_LENGTH:
                        minLenPolicy = policy;
                        break;

                    case vTypes.MAX_LENGTH:
                        maxLenPolicy = policy;
                        break;

                    case vTypes.MIN_LETTER:
                        tipData.push("At least " + policy.value + " letter" + s + " (aA-zZ)");
                        validations.push("'${VALUE}'.match(/([a-zA-Z])/g) && ('${VALUE}'.match(/([a-zA-Z])/g)).length >= " + policy.value);
                        //errMsgs.push(policy.value + " letter" + s);
                        break;

                    case vTypes.MIN_NUMERIC:
                        tipData.push("At least " + policy.value + " number" + s + " (0-9)");
                        validations.push("'${VALUE}'.match(/[0-9]/g) && ('${VALUE}'.match(/[0-9]/g)).length >= " + policy.value);
                        //errMsgs.push(policy.value + " number" + s);
                        break;

                    case vTypes.MIN_LOWERCASE:
                        tipData.push("At least " + policy.value + " lowercase letter" + s + " (a-z)");
                        validations.push("'${VALUE}'.match(/[a-z]/g) && ('${VALUE}'.match(/[a-z]/g)).length >= " + policy.value);
                        //errMsgs.push(policy.value + " lowercase");
                        break;

                    case vTypes.MIN_UPPERCASE:
                        tipData.push("At least " + policy.value + " uppercase letter" + s + " (A-Z)");
                        validations.push("'${VALUE}'.match(/[A-Z]/g) && ('${VALUE}'.match(/[A-Z]/g)).length >= " + policy.value);
                        //errMsgs.push(policy.value + " uppercase");
                        break;

                    case vTypes.MIN_SPECIAL_CHAR_FROM:
                        let wArr = policy.valuesFrom.split("");
                        tipData.push("At least " + policy.value + " special character" + s + " (" + wArr.join("&nbsp;") + ")");
                        validations.push("'${VALUE}'.match(/[" + policy.valuesFrom + "]/g) && ('${VALUE}'.match(/[" + policy.valuesFrom + "]/g)).length >= " + policy.value);
                        //errMsgs.push(policy.value + " special character" + s);
                        break;

                    case vTypes.MIN_SPECIAL_CHAR:
                        tipData.push("At least " + policy.value + " special character" + s + " ($!#?, etc.)");
                        validations.push("'${VALUE}'.match(/[^A-Z0-9]/gi) && ('${VALUE}'.match(/[^A-Z0-9]/gi)).length >= " + policy.value);
                        //errMsgs.push(policy.value + " special character" + s);
                        break;
                }
            });
            if (minLenPolicy && maxLenPolicy) {
                tipData.unshift("Between " + minLenPolicy.value + " and " + maxLenPolicy.value + " characters");
                validations.unshift("/^.{" + minLenPolicy.value + "," + maxLenPolicy.value + "}$/.test('${VALUE}')");
                // errMsgs.unshift(minLenPolicy.value + " to " + maxLenPolicy.value + " characters");
            } else if (minLenPolicy) {
                s = (minLenPolicy.value > 1 ? "s" : "");
                tipData.unshift("At least " + minLenPolicy.value + " character" + s);
                validations.unshift("/^.{" + minLenPolicy.value + ",}/.test('${VALUE}')");
                //errMsgs.unshift("at least " + minLenPolicy.value + " character" + s);
            } else if (maxLenPolicy) {
                s = (maxLenPolicy.value > 1 ? "s" : "");
                tipData.unshift("Max " + maxLenPolicy.value + " character" + s);
                validations.unshift("/^.{0," + maxLenPolicy.value + "}$/.test('${VALUE}')");
                //errMsgs.unshift(maxLenPolicy.value + " or less character" + s);
            }
            if (tipData.length > 0) {
                let notRepeatCount;
                switch (policyType) {
                    case PolicyTypeEnum.PASSWORD_POLICY:
                        prefix = "Password";
                        notRepeatCount = this.getNotRepeatCount(PolicyTypeEnum.RESET_PASSWORD_POLICY);
                        break;
                    case PolicyTypeEnum.VAULT_KEY_POLICY:
                        prefix = "Vault Key";
                        notRepeatCount = this.getNotRepeatCount(PolicyTypeEnum.RESET_VAULT_KEY_POLICY);
                        break;
                }
                if (!!notRepeatCount) {
                    tipData.push("Last " + notRepeatCount + " " + prefix + " cannot be reused.");
                }
                rtnToolTip = prefix + " must contain the following:<ol><li>" + tipData.join("</li><li>") + "</li></ol>";
            }
        }
        return {
            tooltip: rtnToolTip,
            validationString: validations.join(" && "),
            errorMessage: prefix + " does not meet criteria."
            // errorMessage: prefix + " should have " + errMsgs.slice(0,errMsgs.length-1).join(", ") + " and "+ errMsgs[errMsgs.length-1]
        };
    }

    isValidValue(policyType: PolicyTypeEnum, value: string): boolean {
        var policy = this.validationPolicies[policyType];
        var isValid = false;
        if (!!policy) {
            value = value ? value : "";
            var condition = policy.validationString.replace(/\${VALUE}/g, value);
            isValid = eval(condition);
        }
        return isValid;
    }

    getHtmlTooltip(policyType: PolicyTypeEnum): string {
        if (!!this.validationPolicies[policyType]) {
            return this.validationPolicies[policyType].htmlToolTip;
        } else {
            return "";
        }
    }
    getPwdErrMessage(policyType: PolicyTypeEnum): string {
        if (!!this.validationPolicies[policyType]) {
            return this.validationPolicies[policyType].errorMessage;
        } else {
            return "";
        }
    }
    getExipryDays(policyType: PolicyTypeEnum): string {
        let millis = '0';
        if (!!this.validationPolicies[policyType]) {
            let policies = this.validationPolicies[policyType].policies;
            policies.forEach(policy => {
                if (policy.validationType == ValidationTypeEnum.RESET_IN_MILLIS) {
                    millis = Math.floor(policy.value / (24 * 60 * 60 * 1000)).toString();
                }
            });
        }
        return millis;
    }

    getNotRepeatCount(policyType: PolicyTypeEnum): string {
        let notRepeatCount;
        if (!!this.validationPolicies[policyType]) {
            let policies = this.validationPolicies[policyType].policies;
            policies.forEach(policy => {
                if (policy.validationType == ValidationTypeEnum.NOT_USUABLE_PASSWORDS) {
                    notRepeatCount = policy.value;
                }
            });
        }
        return notRepeatCount;
    }

    reset() {
        this.validationPolicies = [];
    }
}

angular.module('eCareVault.common.services')
    .service('ValidationService', ValidationService);